// es/views/channelOta.js
export const channelOta = {
  common: {
    listing: "Anuncio",
    back: "Volver",
    close: "Cerrar",
    cancel: "Cancelar",
    flexible: "Flexible",
    noResults: "Sin coincidencias",
    deleteConn: "Eliminar conexión",
  },
  head: {
    manage: "Administrar {channel}",
    airbnbConfig: "Configuración de Airbnb",
    channelOptions: "Opciones del canal",
  },
  picker: {
    placeholder: "Busca o elige un anuncio…",
  },
  loading: {
    status: "Cargando estado del canal…",
    listings: "Cargando tus anuncios de Airbnb…",
    settings: "Cargando ajustes del anuncio…",
  },
  accounts: {
    title: "¿A cuál de tus cuentas de {channel}?",
    lead: "Ya tienes una cuenta de {channel} conectada. Puedes añadir este anuncio a ella o conectar otra cuenta distinta. | Ya tienes {n} cuentas de {channel} conectadas. Elige a cuál va este anuncio, o conecta otra.",
    account: "Cuenta {n}",
    empty: "Todavía sin anuncios",
    andMore: "{list} y {rest} más",
    newTitle: "Conectar otra cuenta de {channel}",
    newDesc: "Para anuncios que están en una cuenta distinta",
  },
  confirm: {
    title: "Eliminar conexión de {channel}",
    desc: "Se quitará el canal del channel manager y de tus conexiones activas.",
    coversPre: "Esta conexión cubre ",
    coversCount: "{count} anuncio | {count} anuncios",
    coversPost: " y se desconectará de todos: {list}",
    purgePre: "¿Eliminar también reservas importadas? Elige de qué habitaciones ",
    purgeNote: "(se pueden recuperar)",
    selectAll: "Todas",
    unselectAll: "Quitar todas",
    delete: "Eliminar",
    detachOnly: "Desconectar solo este anuncio",
    deleteAll: "Eliminar y desconectar {count} anuncio | Eliminar y desconectar los {count} anuncios",
    deleteWithResv: "Eliminar (+{count} reserva) | Eliminar (+{count} reservas)",
  },
  gone: {
    title: "Esta conexión ya no existe en el canal",
    desc: "El canal fue eliminado en el channel manager. Elimina esta conexión para poder volver a conectarlo desde “Conectar ahora”.",
  },
  menu: {
    channelOptDesc: "Activar o pausar, editar el mapeo, sincronizar, extraer reservas o eliminar la conexión.",
    airbnbCfgDesc: "Horarios de check-in/out, antelación, precios y limpieza de cada anuncio.",
  },
  channel: {
    statusLabel: "Estado del canal",
    active: "Activo",
    inactive: "Inactivo",
    deactivate: "Desactivar canal",
    activate: "Activar canal",
    pending: "En revisión",
    hintPending: "El canal está conectado y ya tiene tus datos. Falta que el canal revise y acepte tu alojamiento; cuando lo haga se activa solo. Suele tardar unos días. Si pasa de ahí, escríbenos y lo miramos.",
    hintActive: "El canal está activo: enviamos precios y disponibilidad. Desactívalo para pausar el envío sin perder el mapeo.",
    blockersTitle: "Falta algo para que el canal se active",
    blockersHint: "En cuanto pulses “Conectar” otra vez en el asistente, lo ajustamos y volvemos a enviarlo.",
    hintInactive: "El canal está conectado pero pausado. Actívalo para empezar a enviar precios y disponibilidad.",
    editTitle: "Editar canal",
    editDesc: "Cambia o añade habitaciones y tarifas mapeadas a este canal.",
    editBtn: "Editar mapeo",
    fullSyncTitle: "Sincronización completa",
    fullSyncDesc: "Reenvía todos los precios, disponibilidad y restricciones al canal.",
    synced: "Sincronizado",
    sync: "Sincronizar",
    extractTitle: "Extraer reservas futuras",
    extractDesc: "Importa a WACheckin las reservas que ya tengas en el canal.",
    imported: "Importadas",
    extract: "Extraer",
    resyncTitle: "Re-importar reservas",
    resyncDesc: "Vuelve a traer todas las reservas del canal y las re-asigna con el mapeo actual. Úsalo si te equivocaste de anuncio o faltan reservas.",
    resync: "Re-importar",
  },
  cfg: {
    emptyNoListings: "Aún no has emparejado ningún anuncio. Ve a <b>Opciones del canal → Editar mapeo</b> para conectar tus anuncios de Airbnb con tus unidades.",
    emptyNoMapping: "Este alojamiento todavía no tiene ningún anuncio de Airbnb emparejado. Ve a <b>Opciones del canal → Editar mapeo</b> y empareja su anuncio para poder configurar aquí sus horarios y precios.",
  },
  arrival: {
    section: "Llegada y salida",
    lead: "A qué horas y qué días pueden entrar y salir tus huéspedes.",
    checkInFrom: "Check-in desde",
    checkInFromTip: "Hora más temprana a la que un huésped puede hacer el check-in.",
    checkInTo: "Check-in hasta",
    checkInToTip: "Hora más tardía a la que un huésped puede llegar.",
    checkOut: "Check-out",
    checkOutTip: "Hora límite a la que el huésped debe dejar el alojamiento.",
    unset: "Sin definir",
    daysIn: "Días que se puede entrar",
    daysInTip: "Días de la semana en los que un huésped puede hacer el check-in.",
    daysOut: "Días que se puede salir",
    daysOutTip: "Días de la semana en los que un huésped puede hacer el check-out.",
  },
  booking: {
    section: "Reservas",
    window: "Ventana de disponibilidad",
    windowTip: "Con cuánta antelación se abre tu calendario a la venta. Es lo que Airbnb llama 'ventana de disponibilidad' (12 meses = 365 días). NO es el máximo de noches por estancia.",
    minLead: "Antelación mínima",
    minLeadTip: "Cuánto tiempo antes de la llegada se puede reservar. Evita reservas de última hora.",
    maxStay: "Estancia máxima",
    maxStayTip: "Número máximo de noches por reserva. Es el 'número máximo de noches' de Airbnb, distinto de la ventana de disponibilidad.",
    turnover: "Días entre reservas",
    turnoverTip: "Días que se bloquean entre una salida y la siguiente entrada, para limpiar y preparar.",
  },
  rules: {
    section: "Reglas de reserva",
    cancelPolicy: "Política de cancelación",
    cancelPolicyTip: "Cuánto puede recuperar el huésped si cancela. Flexible = más permisiva; Estricta = menos reembolso.",
    whoCanBook: "Quién puede reservar",
    whoCanBookTip: "Quién puede reservar al instante sin tu aprobación previa.",
  },
  prices: {
    section: "Precios",
    perNight: "Precio por noche",
    weekend: "Precio fin de semana",
    weekendTip: "Precio para viernes y sábado. Déjalo igual al de noche si no quieres diferenciar.",
    guestsIncluded: "Huéspedes incluidos",
    guestsIncludedTip: "Número de huéspedes sin coste adicional.",
    extraGuest: "Precio huésped extra",
    extraGuestTip: "Coste por cada huésped adicional, por noche, a partir de los incluidos.",
  },
  cleaning: {
    section: "Limpieza",
    notePre: "Rellena las dos para que toda reserva pague limpieza. La de estancia larga debe ser ",
    noteStrong: "igual o mayor",
    notePost: " que la de corta. Si dejas una en 0, ese tipo de estancia no pagará limpieza.",
    long: "Limpieza · estancia larga",
    longTip: "Se cobra en estancias largas. Debe ser igual o mayor que la de estancia corta.",
    short: "Limpieza · estancia corta",
    shortTip: "Se cobra en estancias breves (pocas noches).",
    error: "La limpieza de estancia larga ({sym}{long}) debe ser igual o mayor que la de corta ({sym}{short}).",
  },
  tax: {
    section: "Tasa turística",
    lead: "Impuesto local que cobras al huésped y declaras tú (no Airbnb). Déjala en 0 si no aplica.",
    amount: "Importe",
    amountTip: "Cantidad de la tasa. Pon 0 para no aplicarla.",
    charged: "Se cobra",
    chargedTip: "Cómo se calcula la tasa: por cada huésped y noche, por noche, o por huésped.",
    perGuestNight: "Por huésped y noche",
    perNight: "Por noche",
    perGuest: "Por huésped",
    attestation: "Confirmo que esta información es correcta y que asumo la responsabilidad de cobrar y declarar esta tasa.",
  },
  footer: {
    save: "Guardar configuración",
    saving: "Guardando…",
  },
  opts: {
    noticeNoLimit: "Sin límite (todas las fechas)",
    months: "{count} mes | {count} meses",
    maxNoLimit: "Sin límite",
    nights: "{count} noche | {count} noches",
    maxNights: "Máximo ({count})",
    cancelModerate: "Moderada",
    cancelFirm: "Firme",
    cancelStrict: "Estricta",
    instantEveryone: "Cualquier huésped",
    instantWellReviewed: "Con buenas valoraciones",
    instantVerified: "Identidad verificada",
    instantReviewedVerified: "Valoraciones + identidad",
    leadNone: "Sin antelación",
    hours: "{count} hora | {count} horas",
    days: "{count} día | {count} días",
  },
  msg: {
    loadSettingsError: "No se pudieron cargar los ajustes del anuncio.",
    taxAttestationWarn: "Marca la casilla de declaración para aplicar la tasa turística.",
    saveOk: "Configuración de Airbnb guardada y enviada al canal.",
    saveError: "No se pudo guardar la configuración.",
    statusError: "No se pudo cargar el estado del canal.",
    activated: "Canal activado.",
    deactivated: "Canal desactivado.",
    toggleError: "No se pudo cambiar el estado del canal.",
    resyncOk: "Reservas re-importadas: {imported}.",
    resyncOkWarn: "Reservas re-importadas: {imported} ({errors} con aviso).",
    resyncError: "No se pudieron re-importar las reservas.",
    disconnectError: "No se pudo eliminar la conexión.",
    fullSyncOk: "Sincronización completa enviada.",
    extractOk: "Reservas futuras importadas.",
    actionError: "No se pudo ejecutar la acción.",
  },
  rate: {
    apply: "Aplicar",
    or: "o",
    usePlan: "usa una tarifa tuya…",
  },
};
